import dayjs from 'dayjs';
import { LoginBody } from '../../pages/SignInComponent';
import { LoginStateType } from '../../utils/type';
import { ApiResponseHandler } from '../ApiResponseHandler';
import UserApiClient from '../UserApiClient';
import { AuthBody } from '../../pages/AuthScreen';

export const loginUser = async (params: LoginBody): Promise<LoginStateType> => {
  const timezone = encodeURIComponent(dayjs(new Date()).format('Z'));
  const zoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return ApiResponseHandler(
    await UserApiClient.getInstance().post<LoginBody, LoginStateType>(
      `login?timezone=${timezone}&zoneName=${zoneName}`,
      params,
    ),
  );
};

export const loginEntraId = async (
  params: AuthBody,
): Promise<LoginStateType> => {
  const zoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return ApiResponseHandler(
    await UserApiClient.getInstance().post<AuthBody, LoginStateType>(
      `login?zoneName=${zoneName}`,
      params,
    ),
  );
};

export const signOutUser = async (refreshToken: string) => {
  return ApiResponseHandler(
    await UserApiClient.getInstance().post('signout', {
      refreshToken: refreshToken,
    }),
  );
};
